module.exports = __webpack_public_path__ + "img/1.b3368e5a.jpg";